import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { updateTempImagesMutation as mutation } from '../../../lib/graphql';

export const updateTempImages = (tableName, fieldName, fileName) => {

  return async (dispatch, getState, { client }) => {

    const { data } = await client.mutate({
      mutation,
      variables: {
        tableName,
        fieldName,
        fileName
      }
    });


    if (data?.updateTempImages?.status == 200) {
      showToaster({ messageId: 'tempImage', requestContent: { fileName }, toasterType: 'success' });
    } else {
      showToaster({ messageId: 'errorMessage', toasterType: 'error' });
    }
  }
}